import '../styles/components/Footer.css';
import logo from '../assets/logo.png';

const PAGE_LINKS = [
  { label: 'Home',            page: 'home' },
  { label: 'Products',        page: 'products' },
  { label: 'About Us',        page: 'about' },
  { label: 'Global Presence', page: 'presence' },
  { label: 'Quality',         page: 'quality' },
  { label: 'Contact',         page: 'contact' },
];

const PRODUCT_LINKS = [
  'Erythromycin Range',
  'Diclofenac Range',
  'Fluoroquinolones',
  'Anti-Inflammatories',
  'Cardiovascular APIs',
];

const CONTACT_LINKS = [
  { label: 'Export Enquiries', href: 'mailto:export@phrmchem.net' },
  { label: 'Domestic Sales',   href: 'mailto:sales@phrmchem.net' },
  { label: 'Management',       href: 'mailto:nipun@phrmchem.net' },
  { label: '+91 98108 20562',  href: 'tel:+919810820562' },
  { label: 'www.pharmchem.net.in', href: 'http://www.pharmchem.net.in' },
];

const CERT_LINKS = ['WHO GMP', 'IP / BP / USP', 'EP / IH', 'Drug Master Files', 'MNC Approvals'];

function Footer({ navigate }) {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-top">

          {/* Brand */}
          <div className="footer-brand">
            <div className="fb-logo">
              <img className="fb-logo-img" src={logo} alt="Pharmchem Logo" />
            </div>
            <p>
              WHO GMP Certified Indian API manufacturer since 1976 — delivering quality
              Active Pharmaceutical Ingredients to formulators in 33+ countries worldwide.
            </p>
            <div className="footer-since">Est. 1976 · Gurugram, India</div>
          </div>

          {/* Pages */}
          <div className="footer-col">
            <h4>Pages</h4>
            <ul>
              {PAGE_LINKS.map((item) => (
                <li key={item.page}>
                  <button onClick={() => navigate(item.page)}>{item.label}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          {/* <div className="footer-col">
            <h4>Products</h4>
            <ul>
              {PRODUCT_LINKS.map((label) => (
                <li key={label}>
                  <button onClick={() => navigate('products')}>{label}</button>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              {CONTACT_LINKS.map((item) => (
                <li key={item.label}>
                  <a href={item.href} target={item.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Certifications */}
          <div className="footer-col">
            <h4>Certifications</h4>
            <ul>
              {CERT_LINKS.map((label) => (
                <li key={label}><a href="#top">{label}</a></li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar — full width */}
      <div className="footer-bottom" style={{ padding: '24px 6%' }}>
        <p>© 2025 Pharmchem. All rights reserved. · Building Business through Long Term Relations</p>
        <div className="footer-bottom-links">
          <a href="#top">Privacy Policy</a>
          <a href="#top">Terms of Use</a>
          <a href="#top">Sitemap</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
